import React, { useState } from 'react';
import MaintenanceList from '../components/MaintenanceLogList';
import './MaintenanceScreen.css';
import { LogType } from '../interfaces/LogType';
import { SettingsType, UserType } from '../interfaces/SettingsType';
import MaintenanceRepairLogList from '../components/MaintenanceRepairLogList';
import { MaintenanceLogType } from '../interfaces/MaintenanceLogType';
import MaintenanceRepairDetailModal from '../components/MaintenanceRepairDetailModal';

interface MaintenanceScreenProps {
  settings: SettingsType;
  initLogs: LogType[];
  pilots: UserType[];
}

const MaintenanceScreen: React.FC<MaintenanceScreenProps> = ({
  settings,
  initLogs,
  pilots,
}) => {
  const [logList, setLogList] = useState<LogType[]>(initLogs);

  const [showModal, setShowModal] = useState(false);
  const [currentLog, setCurrentLog] = useState<MaintenanceLogType | null>(null);

  const [refresh, setRefresh] = useState(false)

  const [itemsPerPage, setItemsPerPage] = useState<number>(8);
  const availableOptions = [4, 8, 12, 24];

  const cycleItemsPerPage = () => {
    const currentIndex = availableOptions.indexOf(itemsPerPage);
    const nextIndex = (currentIndex + 1) % availableOptions.length;
    setItemsPerPage(availableOptions[nextIndex]);
  };

  const openModal = (log?: MaintenanceLogType) => {
    setCurrentLog(log || null);
    setShowModal(true);
  };

  const closeModal = (log?: MaintenanceLogType) => {
    setShowModal(false);
    setRefresh(!refresh)
  };

  return (
    <div className="maintenance-container">
      <div className="maintenance-loglist">
        <div className="maintenance-title">
          <h2>Wartungsbuch</h2>
          <div className="button-group">
            <button className="add-button-maintenance" onClick={cycleItemsPerPage}>
              {itemsPerPage} pro Seite
            </button>
            <button className="add-button-maintenance" onClick={() => openModal()}>
              + Neue Wartung
            </button>
          </div>
        </div>
        {showModal && (
          <MaintenanceRepairDetailModal
            log={currentLog}
            onClose={closeModal}
            isAdmin={settings.isAdmin ?? false}
            pilots={pilots}
          />
        )}
        {logList && (
          <MaintenanceRepairLogList
            itemsPerPage={itemsPerPage}
            isAdmin={settings.isAdmin}
            key={"MaintenanceRepairLogList" + refresh}
            pilots={pilots}
          />
        )}
        <div className="maintenance-title">
          <h2>Wartungslog DJI Matrice 350</h2>
        </div>
        <MaintenanceList />
      </div>
    </div>
  );
};

export default MaintenanceScreen;
